// extracted by mini-css-extract-plugin
export default {"content":"Home_content__qrD-+","text":"Home_text__bwQM6"};